
import { Chart as ChartJS } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register( ChartDataLabels )
window.addEventListener("dragover", (e) => {
  e.preventDefault();
});

window.addEventListener("drop", (e) => {
  e.preventDefault();
});

ChartJS.defaults.plugins.datalabels.clamp = true;
ChartJS.defaults.plugins.datalabels.anchor = (context) => {
   const value = context.dataset.data[context.dataIndex];
      return value >= 0 ? "end" : "start";
};

ChartJS.defaults.plugins.datalabels.align = (context) => {
     const value = context.dataset.data[context.dataIndex];
    const min = Math.min(...context.dataset.data);
    return value > min ? "bottom" : "top";
};

import './bootstrap';
import '../scss/main.scss'; //Styles entry point.
import { createApp, h } from 'vue'
import { createInertiaApp, Link } from '@inertiajs/vue3'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';


createInertiaApp({
  resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
  setup: ({ el, App, props, plugin }) => {

    const app = createApp({ render: () => h(App, props) })
      .use(plugin)
      .mixin({ methods: { route: window.route } })
      .component('Link', Link)
      .mount(el);

  },
});
//

// import Alpine from 'alpinejs';

// window.Alpine = Alpine;

// Alpine.start();
